import React, { useEffect } from "react";
import { compose } from 'redux';
import { push } from "connected-react-router";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Grid, Link, Tooltip, Typography, Select, Input, MenuItem, Checkbox, ListItemText } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import MyTasksGridRow from "./MyTasksGridRow";
import { Constants } from "../../../../utilities/constants";
import {
  fetchDashboardTasks,
  fetchUsers,
  setMyTasksSelectedUsers,
  setChannelWorkflowGridStateUpdate
} from "../../../../store/actions";
import { userRoleUnderwriteManagerSelector } from "../../../../store/selectors";
import { LoadingOverlayWrapper } from "../../../layout";
import { sendClientLog } from 'services/logService';

const CHANNELS = [
  //{ name: 'Auction', abbr: 'A', title: 'Auction' },
  //{ name: 'BulkSale', abbr: 'BS', title: 'Bulk Sale' },
  //{ name: 'BuildToRent', abbr: 'B2R', title: 'Build to Rent' },
  { name: 'MLS', abbr: 'MLS', title: 'MLS' },
  { name: 'OffMarket', abbr: 'OM', title: 'Off Market' },
];

const MY_TASK_TYPES = [
  {key: 'Incomplete', text: 'Incomplete'},
  {key: Constants.UnderwriteStatus.AUTOPRICED, text: 'Autopriced'},
  {key: Constants.UnderwriteStatus.PENDING, text: 'Pending'},
  {key: Constants.UnderwriteStatus.SAVEDPRICING, text: 'Saved Pricing'},
  {key: Constants.UnderwriteStatus.SAVEDNOBID, text: 'Saved No Bid'},
  {key: Constants.UnderwriteStatus.SUBMITTEDPRICING, text: 'Submitted Pricing'},
  {key: Constants.UnderwriteStatus.SUBMITTEDNOBID, text: 'Submitted No Bid'},
]

const MyTasks = ({
  classes,
  currentUser,
  dashboardAvailableTasks,
  dashboardChannels,
  dashboardTasks,
  fetchDashboardTasks,
  fetchUsers,
  myTasksIsLoading,
  availableIsLoading,
  push,
  selectedUsers,
  setChannelWorkflowGridStateUpdate,
  setMyTasksSelectedUsers,
  user,
  userHasUnderwriteManagerRole,
  users,
}) => {
  useEffect(() => {
   if (users.length === 0) {
      fetchUsers();
    }
  }, []);

  function handleRedirectToWorkflow(channel) {
    // stay on dashboard page if user doesn't have Underwrite role
    if (!user?.roles?.underwriteUser) {
      return;
    }

    sendClientLog('Info', 'User clicked link on dashboard to navigate to workflow (' + channel + ').');
    let filterValue = [['channelText', '=', channel]];
    setChannelWorkflowGridStateUpdate({ filterValue: filterValue }, true);
    push(Constants.Routes.CHANNEL_WORKFLOW);
  }

  function getFilteredUsers() {
    const systemUsers = [
      Constants.Username.AUTOCALC,
      Constants.Username.MLSFEED,
      Constants.Username.CRMFEED
    ]

    const filtered = users
      .filter(user => !systemUsers.includes(user.name))
      .filter(user => user.id !== currentUser.id)
      .map(u => {return {id: u.id, name: u.fullName}});
    filtered.unshift({id: currentUser.id, name: currentUser.fullName});

    return filtered;
  }

  function getUsersFilter() {
    const mySelectedUsers = selectedUsers || [currentUser.id];
    if (!userHasUnderwriteManagerRole) {
      return;
    }

    const dataSource = getFilteredUsers();

    return (
      <Select
        multiple
        value={mySelectedUsers}
        onChange={handleUserChange}
        input={<Input />}
        style={{ width: '100%', marginBottom: 4 }}
        renderValue={(selected) => selected.map(id => dataSource.find(user => user.id === id)?.name).join(', ')}
        MenuProps={{ 
          style: { maxHeight: 600 },
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' }
        }}
      >
        {dataSource.map((user) => (
          <MenuItem key={user.id} value={user.id} dense>
            <Checkbox checked={mySelectedUsers.indexOf(user.id) > -1} />
            <ListItemText primary={user.name} />
          </MenuItem>
        ))}
      </Select>
    );
  }

  function handleUserChange(event) {
    const selectedUsers = event.target.value;

    setMyTasksSelectedUsers(selectedUsers);
    fetchDashboardTasks(dashboardChannels, selectedUsers);
  }

  function getGridHeaderClass(channel) {
    if (dashboardChannels.indexOf(channel) < 0) {
      return classes.greyed;
    }
  }

  function getGridHeaderItem(channelsData = CHANNELS) {
    const color = 'inherit';
    return channelsData.map((channel) => {
      return (
        <Grid
          key={channel.name}
          item
          xs={1}
          className={getGridHeaderClass(channel.name)}
        >
            <Tooltip
              color={color}
              title={channel.title}>
                <Link
                  color={color}
                  href="#"
                  onClick={() => handleRedirectToWorkflow(channel.name)}>
                  {channel.abbr}
                </Link>
            </Tooltip>
        </Grid>
      )
    });
  }

  function getGridHeaders() {
    return (
      <Grid container className={`${classes.gridRow} ${classes.gridLabelFormat}`} >
        <Grid item xs={6}></Grid>
        { getGridHeaderItem() }
        <Grid item xs={1}><Tooltip title="Total"><div>T</div></Tooltip></Grid>
      </Grid>
    );
  }

  function getGridRows(taskTypes = MY_TASK_TYPES) {
    return taskTypes.map((type) =>
      (<MyTasksGridRow
        key={type.key}
        channels={CHANNELS}
        tasksType={type.key}
        tasksText={type.text}
        dashboardAvailableTasks={dashboardAvailableTasks}
        dashboardTasks={dashboardTasks}
        dashboardChannels={dashboardChannels}
        user={user}
      />)
    );
  }

  return (
    <>
      <LoadingOverlayWrapper
        active={availableIsLoading}
        message={availableIsLoading ? 'Fetching tasks...' : ''}
        className={classes.loadingOverlayWrapper}
        background={'rgba(242, 242, 242, 0.9)'}
      >
        <Grid container className={classes.gridRoundedContainer} >
          <Grid item xs={12} className={classes.myTasksHeader}>
            <Typography variant="h6">Available Opps</Typography>
          </Grid>
          {getGridHeaders()}
          {userHasUnderwriteManagerRole
            ? <MyTasksGridRow
              channels={CHANNELS}
              tasksType={'Imported'}
              dashboardAvailableTasks={dashboardAvailableTasks}
              dashboardTasks={dashboardTasks}
              dashboardChannels={dashboardChannels}
              user={user}
            />
              : ''
          }
          <MyTasksGridRow
            channels={CHANNELS}
            tasksType={'Available'}
            dashboardAvailableTasks={dashboardAvailableTasks}
            dashboardTasks={dashboardTasks}
            dashboardChannels={dashboardChannels}
            user={user}
          />
        </Grid>
      </LoadingOverlayWrapper>
      <LoadingOverlayWrapper
        active={myTasksIsLoading}
        message={myTasksIsLoading ? 'Fetching tasks...' : ''}
        className={classes.loadingOverlayWrapper}
        background={'rgba(242, 242, 242, 0.9)'}
      >
        <Grid container className={classes.gridRoundedContainer} style={{marginTop: 10}}>
          <Grid item xs={4} className={classes.myTasksHeader}>
            <Typography variant="h6">My Opps</Typography>
          </Grid>
          <Grid item xs={8} className={classes.myTasksHeader} style={{textAlign: 'right'}}>
            {getUsersFilter()}
          </Grid>
          {getGridHeaders()}
          {getGridRows()}
        </Grid>
      </LoadingOverlayWrapper>
    </>
  );
}

const styles = theme => ({
  gridRoundedContainer: {
    border: '1px solid #000',
    borderRadius: '4px'
  },
  myTasksHeader: {
    textAlign: 'left',
    padding: '5px 0px 2px 8px',
  },
  gridRow: {
    marginBottom: '10px',
    fontWeight: '700',
    paddingRight: 10,
  },
  greyed: {
    color: 'rgba(200, 200, 200, 0.85)',
  },
  gridLabelFormat: {
    textAlign: 'end',
  },
  search: {
    '& div.e-multi-select-wrapper span.e-delim-view': {
      paddingRight: 30
    }
  }
});

const mapStateToProps = (state) => ({
  userHasUnderwriteManagerRole: userRoleUnderwriteManagerSelector(state),
  user: state.appState.user,
  users: state.appState.users,
  myTasksIsLoading: state.dashboardState.myTasksIsLoading,
  availableIsLoading: state.dashboardState.availableIsLoading,
});

const mapDispatchToProps = {
  fetchDashboardTasks,
  setChannelWorkflowGridStateUpdate,
  push,
  fetchUsers,
  setMyTasksSelectedUsers
};

export default compose(
  withRouter,
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(MyTasks);
